import createModel, {
  arbitraryKeys,
  Optional,
  Silent,
} from "@/__main__/data-model.mjs";

const apiModelValidation = createModel({
  [arbitraryKeys]: {
    [arbitraryKeys]: {
      name: String,
      description: Silent(String),
      icon: Silent(String),
      key: Silent(String),
      type: Optional(String),
    },
  },
});

export const localizedAugments = createModel({
  [arbitraryKeys]: {
    [arbitraryKeys]: {
      name: String,
      description: Silent(String),
      icon: Silent(String),
      key: Silent(String),
      type: Optional(String),
    },
  },
});

function transform(data) {
  return apiModelValidation(data);
}

export default transform;
